import { cva } from '../tokens/variants';

/** Track (the surface behind the bar). */
export const progressTrackVariants = cva(
  'w-full overflow-hidden rounded-tk-full bg-[var(--tk-surface-bg)]',
  {
    variants: {
      size: {
        sm: 'h-1',
        md: 'h-2',
        lg: 'h-3',
      },
    },
    defaultVariants: { size: 'md' },
  },
);

/** Filled bar — color matches the tone. */
export const progressBarVariants = cva(
  'h-full rounded-tk-full transition-[width] duration-300 ease-out',
  {
    variants: {
      tone: {
        brand: 'bg-[var(--tk-brand-bg)]',
        success: 'bg-[var(--tk-success-bg)]',
        danger: 'bg-[var(--tk-danger-bg)]',
        warning: 'bg-[var(--tk-warning-bg)]',
        info: 'bg-[var(--tk-info-bg)]',
      },
      indeterminate: {
        true: 'animate-pulse',
        false: '',
      },
    },
    defaultVariants: { tone: 'brand', indeterminate: false },
  },
);
